import { render, staticRenderFns } from "./Refundmoney.vue?vue&type=template&id=3d27cf8e&scoped=true&"
import script from "./Refundmoney.vue?vue&type=script&lang=js&"
export * from "./Refundmoney.vue?vue&type=script&lang=js&"
import style0 from "./Refundmoney.vue?vue&type=style&index=0&id=3d27cf8e&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d27cf8e",
  null
  
)

export default component.exports